import { LimitOrder, type OpenOrder } from "#/types/orders";
import { type TradeDirection } from "#/types/trade";

export const getAllOpenOrderRows = (data: OpenOrder[]): OpenOrder[] => {
  if (data.length === 0) return [];

  const emptyFields = {
    date: "",
    orderId: "",
    direction: "buy" as TradeDirection,
    maturity: "",
    filled: 0,
    limitPrice: 0,
    tif: LimitOrder.GTC,
    isLiquidated: false,
  };

  const summary = data.reduce(
    (acc, order) => {
      const key = order.isOption ? "options" : "perps";
      acc[key].count += 1;
      acc[key].size += order.size;
      return acc;
    },
    {
      options: { count: 0, size: 0 },
      perps: { count: 0, size: 0 },
    },
  );

  const result: OpenOrder[] = [];

  if (summary.options.size) {
    result.push({
      isOption: true,
      instrument: `Options (${summary.options.count})`,
      size: summary.options.size,
      ...emptyFields,
    });
  }

  if (summary.perps.size) {
    result.push({
      isOption: false,
      instrument: `Perps (${summary.perps.count})`,
      size: summary.perps.size,
      ...emptyFields,
    });
  }

  return result;
};
